export default __webpack_public_path__ + "static/media/ospitek_logo.8cd6d1e9.png";